var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,40 A30,30 0 0,1 70,40",
    fill: "none",
    stroke: "#333",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,40 A30,30 0 0,1 50,13",
    fill: "none",
    stroke: "#8a76db",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 35,
    textAnchor: "middle",
    fill: "#eee",
    fontFamily: "monospace",
    fontSize: 12
  }, "40%"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeWidget);
export default __webpack_public_path__ + "static/media/gauge-widget.0c914ebb4509d6d9333fed0777916b9a.svg";
export { ForwardRef as ReactComponent };